module.exports = __webpack_public_path__ + "assets/static/png/yasno.baf5efc3dd791dd66d6d859cd029bf8a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/images/yasno.png
 ** module id = 540
 ** module chunks = 1
 **/